/* global axios */
import ApiClient from './ApiClient';

class IungoOnboardingAPI extends ApiClient {
  constructor() {
    super('iungo/onboarding', { accountScoped: true });
  }

  start(name) {
    return axios.post(this.url, { name });
  }

  status(appId) {
    return axios.get(this.url, { params: { app_id: appId } });
  }

  finalize(payload) {
    return axios.post(`${this.url}/finalize`, payload);
  }
}

export default new IungoOnboardingAPI();
